import axios from "axios";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useState } from "react";
import { getApiHeader } from 'utlis/commonfunctions';

import { toast } from "react-toastify";
import { ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import swal from 'sweetalert';

const SERVER_URL = process.env.REACT_APP_API_URL;


function MyAccountRegistration() {
    const navigate = useNavigate();
    const [currentStep, setCurrentStep] = useState(1);
    const [mobileNumber, setMobileNumber] = useState('');
    const [otpSent, setOtpSent] = useState(false);
    const [sessionId, setSessionId] = useState('');
    const [otpToken, setOtpToken] = useState('');
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const [email, setEmail] = useState('');
    const [confirmEmail, setConfirmEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");


    const nextStep = (step) => setCurrentStep(step);

    const handleMobileSubmit = async () => {
        if (!mobileNumber || !/^\d+$/.test(mobileNumber)) {
            swal("", "Please enter a valid mobile number.", "error");
            return;
        }
        setLoading(true);
        const apiUrl = `${SERVER_URL}register-telsim-myaccount/search?mobile_number=${mobileNumber}`;
        try {
            const headers = await getApiHeader();
            const response = await axios.get(apiUrl, { headers });
            const data = response.data;

            if (response.status === 200) {
                setOtpSent(true);
                setSessionId(data.data.session_id);
                setOtpToken(data.data.otp_token);
               
                swal(data.message, data.data.message, "success").then(() => {
                    nextStep(2);
                });
                
            } else {
                swal("Error", data.message || "Failed to send OTP.", "error");
            }
        } catch (error) {
            if (error.response) {
                swal("Error", error.response.data.message || "An error occurred. Please try again.", "error");
            } else {
                swal("Error", "An error occurred. Please try again.", "error");
            }
        
            console.error('Error verifying OTP:', error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleOtpSubmit = async () => {
        const otpString = otp.join("");

        if (otpString.length !== 6) {
            swal("Error", "Please enter a valid 6-digit OTP.", "error");
            return;
        }

        const apiUrl = `${SERVER_URL}register-telsim-myaccount/verify-otp`;

        const formData = new FormData();
        formData.append('mobile_number', mobileNumber);
        formData.append('session_id', sessionId);
        formData.append('otp_token', otpToken);
        formData.append('otp', otpString);

        try {
            setLoading(true);

            const response = await axios.post(apiUrl, formData, {
                headers: await getApiHeader(),
            });

            const data = response.data;

            if (response.status === 200) {
                swal("Success", "OTP verified successfully!", "success").then(()=>{

                    nextStep(3);
                });
            } else {
                swal("Error", data.message || "Failed to verify OTP.", "error");
            }
        } catch (error) {
            console.error('Error verifying OTP:', error.response.data.message);
            swal("Error", error?.response?.data?.message || "Please enter a valid OTP", "error");
        } finally {
            setLoading(false);
        }
    };


    const handleOtpChange = (element, index) => {
        if (/^[0-9]$/.test(element.value) || element.value === '') {
            const newOtp = [...otp];
            newOtp[index] = element.value;
            setOtp(newOtp);

            if (element.nextSibling && element.value !== '') {
                element.nextSibling.focus();
            }
        }
    };


    const handleRegisterSubmit = async () => {
        setErrors({});

        setLoading(true);
        const apiUrl = `${SERVER_URL}register-telsim-myaccount/register`;

        const formData = new FormData();
        formData.append('mobile_number', mobileNumber);
        formData.append('session_id', sessionId);
        formData.append('email_address', email);
        formData.append('email_address_confirm', confirmEmail);
        formData.append('password', password);
        formData.append('password_confirm', confirmPassword);
        formData.append('otp_token', otpToken);

        try {
            const headers = await getApiHeader();

            const response = await axios.post(apiUrl, formData, {
                headers,
            });

            if (response.status === 200) {
                swal("Success", "Registration successful!", "success");
                setTimeout(() => {
                    window.location.reload();
                }, 4000)
                setLoading(false);

            } else {
                swal("Error", response.data.message || "Failed to register.", "error");
            }
        } catch (error) {

            if (typeof error.response.data.message === 'string') {

                swal("Error", error.response.data.message, "error");

            } else {

                setErrors(error.response.data.message);
            }

        } finally {
            setLoading(false);
        }
    };
   
    const handleClose = (event, reason) => {
        if (reason === "clickaway") return;
        setOpen(false); // Close the snackbar
      };

    return (
        <div>
            <DashboardLayout>
                <DashboardNavbar />
                {/* <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} closeOnClick /> */}
               

                <div className="container register-my-account ">
                    <h5>Telsim My Account Registration</h5>

                    <ul className="nav nav-tabs-rma" role="tablist">
                        {/* Navigation for Steps */}
                        <li className="nav-item-rma">
                            <button className={`nav-link-rma ${currentStep === 1 ? 'active' : ''}`}>
                              Enter Mobile Number
                            </button>
                        </li>
                        <li className="nav-item-rma" disabled={!otpSent}>
                            <button className={`nav-link-rma ${currentStep === 2 ? 'active' : ''}`}>
                            Verify OTP
                            </button>
                        </li>
                        <li className="nav-item-rma">
                            <button className={`nav-link-rma ${currentStep === 3 ? 'active' : ''}`}>
                            Register My Account
                            </button>
                        </li>
                    </ul>

                    <div className="tab-rma-content mt-3">
                        {currentStep === 1 && (
                            <div className="tab-pane fade show active">
                                <div className="mb-3">
                                    <label htmlFor="mobileNumber" className="register-myaccount-label">Mobile Number</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Enter mobile number"
                                        value={mobileNumber}
                                        onChange={e => setMobileNumber(e.target.value)}
                                        autoComplete="off"
                                    />
                                </div>
                                <button
                                    className="btn btn-primary"
                                    onClick={handleMobileSubmit}
                                    disabled={loading}
                                    style={{ backgroundColor: '#c11d6c', color: 'white',width:"161px" }}
                                >
                                    {loading ? 'Processing...' : 'Next'}
                                </button>
                            </div>
                        )}

                        {currentStep === 2 && (
                            <div className="tab-pane fade show active">
                                <div className="mb-3">
                                    <label htmlFor="otp" className="register-myaccount-label ">Enter OTP</label>
                                    <div className="d-flex justify-content-right">
                                        {otp.map((_, index) => (
                                            <input
                                                key={index}
                                                type="text"
                                                className="form-control otp-input"
                                                value={otp[index]}
                                                onChange={e => handleOtpChange(e.target, index)}
                                                maxLength="1"
                                                style={{ width: '3rem', marginRight: '0.5rem', textAlign: 'center' }}
                                                autoComplete="off"
                                            />
                                        ))}
                                    </div>
                                </div>
                                <button className="btn btn-primary" style={{ backgroundColor: '#c11d6c', color: 'white' }} onClick={handleOtpSubmit} disabled={loading}>
                                    {loading ? 'Verifying...' : 'Verify OTP'}
                                </button>
                            </div>
                        )}

                        {currentStep === 3 && (
                            <div className="tab-pane fade show active">
                                <div className="mb-3">
                                    <label htmlFor="email" className="register-myaccount-label ">Email Address</label>
                                    <input
                                        type="email"
                                        className={`form-control ${errors.email_address ? 'is-invalid' : ''}`}
                                        value={email}
                                        placeholder="Enter Email Address"
                                        onChange={e => setEmail(e.target.value)}
                                        autoComplete="off"
                                    />
                                    {errors.email_address && (
                                        <div className="invalid-feedback">
                                            {errors.email_address[0]}
                                        </div>
                                    )}
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="confirmEmail" className="register-myaccount-label ">Confirm Email Address</label>
                                    <input
                                        type="email"
                                        className={`form-control ${errors.email_address_confirm ? 'is-invalid' : ''}`}
                                        value={confirmEmail}
                                        onChange={e => setConfirmEmail(e.target.value)}
                                        placeholder="Confirm Email Address"
                                        autoComplete="off"
                                         
                                    />
                                    {errors.email_address_confirm && (
                                        <div className="invalid-feedback">
                                            {errors.email_address_confirm[0]}
                                        </div>
                                    )}
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="password" className="register-myaccount-label ">Password</label>
                                    <input
                                        type="password"
                                        className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                                        value={password}
                                        onChange={e => setPassword(e.target.value)}
                                        placeholder="Enter Password"
                                        autoComplete="off"
                                    />
                                    {errors.password && (
                                        <div className="invalid-feedback">
                                            {errors.password[0]}
                                        </div>
                                    )}
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="confirmPassword" className="register-myaccount-label">Confirm Password</label>
                                    <input
                                        type="password"
                                        className={`form-control ${errors.password_confirm ? 'is-invalid' : ''}`}
                                        value={confirmPassword}
                                        onChange={e => setConfirmPassword(e.target.value)}
                                        placeholder="Confirm Password"
                                        autoComplete="off"
                                    />
                                    {errors.password_confirm && (
                                        <div className="invalid-feedback">
                                            {errors.password_confirm[0]}
                                        </div>
                                    )}
                                </div>
                                <button className="btn btn-primary" style={{ backgroundColor: '#c11d6c', color: 'white',width:"161px" }} onClick={handleRegisterSubmit} disabled={loading}>
                                    {loading ? 'Registering...' : 'Register'}
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </DashboardLayout>
        </div>
    );
}
export default MyAccountRegistration
